import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { ValidationProvider } from 'vee-validate/dist/vee-validate.full.esm'
import { ValidationObserver } from 'vee-validate'
import { BootstrapVue, BootstrapVueIcons, BIcon } from 'bootstrap-vue'
import vueVimeoPlayer from 'vue-vimeo-player'
import carousel from 'v-owl-carousel'
import VueProgressBar from 'vue-progressbar'
import VueSidebarMenu from 'vue-sidebar-menu'
import Axios from 'axios'
import VueCharts from 'vue-chartjs'
import VueCurrencyFilter from 'vue-currency-filter'
import vSelect from 'vue-select'
import VueSweetalert2 from 'vue-sweetalert2'
import Address from './plugins/address'
import VueRecaptcha from 'vue-recaptcha'
import AddressPlugin from '@/api/daerahindonesia/AddressPlugin'
import { formatRupiah, formatPersen } from './helpers/format';
import ToastPlugin from './plugins/toast';
import VueTheMask from 'vue-the-mask';

// CSS
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/font-awesome.min.css'
import './assets/index.scss'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import 'vue-select/dist/vue-select.css'
import '@fortawesome/fontawesome-free/css/all.css'

// Registrasi Plugin
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(vueVimeoPlayer)
Vue.use(VueSidebarMenu)
Vue.use(AddressPlugin)
Vue.use(VueCharts)
Vue.use(VueSweetalert2)
Vue.use(VueRecaptcha)
Vue.use(VueProgressBar, {
  color: '#7DEADF',
  failedColor: '#7DEADF',
  thickness: '4px',
  transition: {
    speed: '0.5s',
    opacity: '0.10s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
})
Vue.use(VueCurrencyFilter, {
  symbol: 'Rp. ',
  thousandsSeparator: '.',
  fractionCount: 0,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})
Vue.use(Address) // Register plugin address global
Vue.use(ToastPlugin);
Vue.use(VueTheMask)

// Komponen Global
Vue.component('carousel', carousel)
Vue.component('BIcon', BIcon)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('v-select', vSelect)

Vue.prototype.$formatRupiah = formatRupiah;
Vue.prototype.$formatPersen = formatPersen;

// Sesi yang dimatikan dari sisi server (mis. admin menekan reset password) hanya bisa
// diketahui browser saat request berikutnya. API menjawabnya dengan HTTP 200 tapi
// meta.code 401, jadi axios menganggapnya sukses — karena itu kedua bentuk diperiksa
// di satu tempat supaya seluruh halaman ikut bereaksi, bukan hanya router guard.
const HALAMAN_TANPA_SESI = ['/login', '/register', '/forgot-password', '/reset-password', '/atur-ulang-password'];

function sesiBerakhir() {
  const path = window.location.pathname;

  if (HALAMAN_TANPA_SESI.some(halaman => path.indexOf(halaman) === 0)) {
    return;
  }

  if (!localStorage.getItem('user')) {
    return;
  }

  localStorage.removeItem('user');
  localStorage.removeItem('selectedTab');

  router.push('/login').catch(() => {});
}

Axios.interceptors.response.use(
  response => {
    const meta = response && response.data && response.data.meta;

    if (meta && meta.code == 401) {
      sesiBerakhir();
    }

    return response;
  },
  error => {
    const response = error && error.response;
    const meta = response && response.data && response.data.meta;

    if (response && (response.status === 401 || (meta && meta.code == 401))) {
      sesiBerakhir();
    }

    return Promise.reject(error);
  }
);

Vue.config.productionTip = false

// Mount Aplikasi
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js